import React, { Component } from "react";
import { Button, Badge, Form, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import { Link } from "react-router-dom";

export default class RepoChanges extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      data: [],
      filteredData: null,
      filterRepoType: "",
      filterEnvironment: "",
      environmentmaster: [],
      tableClms: [
        {
          name: "S.NO",
          selector: (row) => row.deploymentrepochanges_Id,
          sortable: true,
          width: "80px",
        },
        {
          name: "Repo",
          selector: (row) => row.repoName,
          sortable: true,
        },
        {
          name: "Type",
          selector: (row) => row.repoType,
          sortable: true,
          cell: (row) => (
            <Badge bg={row.repoType === "UI" ? "primary" : "success"}>
              {row.repoType}
            </Badge>
          ),
          width: "80px",
        },
        {
          name: "Environment",
          selector: (row) => row.environment,
          sortable: true,
          width: "120px",
        },
        {
          name: "File Path",
          selector: (row) => row.filePath,
          sortable: true,
          wrap: true,
        },
        {
          name: "Change",
          selector: (row) => row.changeType,
          sortable: true,
          cell: (row) => (
            <Badge
              bg={
                row.changeType === "Added"
                  ? "success"
                  : row.changeType === "Deleted"
                  ? "danger"
                  : "warning"
              }
            >
              {row.changeType}
            </Badge>
          ),
          width: "100px",
        },
        {
          name: "Commit Message",
          selector: (row) => row.commitMessage,
          sortable: true,
          wrap: true,
        },
        {
          name: "Author",
          selector: (row) => row.commitAuthor,
          sortable: true,
          width: "120px",
        },
        {
          name: "Date",
          selector: (row) => row.commitDate,
          sortable: true,
          width: "150px",
        },
        {
          name: "Deployed",
          selector: (row) => row.isDeployed,
          cell: (row) => (
            <Badge bg={row.isDeployed == 1 ? "success" : "secondary"}>
              {row.isDeployed == 1 ? "Yes" : "No"}
            </Badge>
          ),
          width: "100px",
        },
        {
          name: "Actions",
          cell: (row) =>
            row.isDeployed == 0 ? (
              <Link to="/deploymentrequestpage">
                <Button size="sm" variant="outline-primary">
                  Raise Request
                </Button>
              </Link>
            ) : null,
          width: "140px",
        },
      ],
    };
  }

  componentDidMount() {
    this.fetchRepoChanges();
    this.fetchEnvironments();
  }

  fetchRepoChanges = () => {
    fetch(configData.api_url + "C_Deploymentrepochanges/list", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("Failed to fetch repo changes");
      });
  };

  fetchEnvironments = () => {
    fetch(configData.api_url + "C_Environmentmaster/list", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ environmentmaster: data.list });
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  handleFilter = () => {
    let filtered = this.state.data;
    if (this.state.filterRepoType) {
      filtered = filtered.filter(
        (r) => r.repoType === this.state.filterRepoType
      );
    }
    if (this.state.filterEnvironment) {
      filtered = filtered.filter(
        (r) => r.environment === this.state.filterEnvironment
      );
    }
    this.setState({ filteredData: filtered });
  };

  clearFilter = () => {
    this.setState({
      filterRepoType: "",
      filterEnvironment: "",
      filteredData: null,
    });
  };

  render() {
    const displayData = this.state.filteredData || this.state.data;
    return (
      <div className="container-fluid p-3">
        <h4>Repository Changes</h4>
        <p className="text-muted">
          View pending changes in your repos. Raise deployment requests for
          changes that need to be deployed.
        </p>

        {/* Filters */}
        <Row className="mb-3">
          <Col md={3}>
            <Form.Select
              value={this.state.filterRepoType}
              onChange={(e) =>
                this.setState({ filterRepoType: e.target.value }, this.handleFilter)
              }
            >
              <option value="">All Repo Types</option>
              <option value="UI">UI</option>
              <option value="API">API</option>
            </Form.Select>
          </Col>
          <Col md={3}>
            <Form.Select
              value={this.state.filterEnvironment}
              onChange={(e) =>
                this.setState({ filterEnvironment: e.target.value }, this.handleFilter)
              }
            >
              <option value="">All Environments</option>
              {this.state.environmentmaster.map((env) => (
                <option
                  key={env.environmentmaster_Id}
                  value={env.environmentName}
                >
                  {env.environmentName}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md={2}>
            <Button variant="secondary" onClick={this.clearFilter}>
              Clear Filters
            </Button>
          </Col>
        </Row>

        <DataTable
          columns={this.state.tableClms}
          data={displayData}
          pagination
          highlightOnHover
          striped
          defaultSortFieldId={1}
          defaultSortAsc={false}
        />
      </div>
    );
  }
}
